import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class RateMaxPrice extends BaseAPIModel {
    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId }) {
        if (!eventId || !organizationId) {
            throw new ArgumentError(`[Model] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/rate_limit`;
    }
}
